import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { catchError, tap } from 'rxjs/operators';
import { HandleErrorService } from './handle-error.service';
import {ApiService} from '../core/services/api.service';

const jwtHelper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private serviceApi: ApiService,
    private handleError: HandleErrorService
  ) { }

  public isAuthenticated(): boolean {
    return !!sessionStorage.getItem('token');
    //return !jwtHelper.isTokenExpired(token);
  }

  refreshTokens(): Observable<any> {
    return this.serviceApi.post<any>(
      `User/RefreshToken`, {application: 1}
    );
  }

  login(params: any): Observable<any> {
    Swal.fire({
      title: 'Vivir Seguros',
      text: 'Por favor espere',
      icon: 'warning',
    }).then();
    Swal.showLoading();
    return this.serviceApi.post(`User/Access`, params)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: any) => {
          Swal.close();
          return data;
        })
      );
  }

  // forgotPassword(params: any): Observable<any> {
  //   Swal.fire({
  //     title: 'Vivir Seguros',
  //     text: 'Por favor espere',
  //     icon: 'warning',
  //   }).then();
  //   Swal.showLoading();
  //   return this.serviceApi.put(`User/ChangePassword`, params)
  //     .pipe(
  //       catchError(this.handleError.catchHttpError),
  //       tap((data: { valid: boolean, message: string }) => {
  //         return Swal.fire({
  //           icon: 'success',
  //           text: data.message,
  //           confirmButtonText: 'Aceptar',
  //         }).then();
  //       })
  //     );
  // }

  recoveryPassword(params: any): Observable<any> {
    Swal.fire({
      title: 'Vivir Seguros',
      text: 'Por favor espere',
      icon: 'warning',
    }).then();
    Swal.showLoading();
    return this.serviceApi.put(`User/CodeVerificate`, params)
      .pipe(
        catchError(this.handleError.catchHttpError),
        tap((data: any) => {
          Swal.close();
          return data;
        })
      );
  }

  logout(token): Observable<any> {
    return this.serviceApi.get(`api/auth/logout?token=${token}`);
  }
}
